import fetchAPI from '../fetchAPI';

/** Delete a model no tier runs. The server refuses (400, with the tier names) if one does. */
export const callDeleteAiModel = async (id: string): Promise<iResponse<{ code: number; message?: string }>> =>
  fetchAPI({ method: `DELETE`, route: `ai-models`, id });

export default callDeleteAiModel;
